export default {
    en: "EN",
    ua: "UA",
    ru: "RU"
}